import React from 'react';
import * as S from './styles';

var RadioButton = function RadioButton(_ref) {
  var children = _ref.children,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      onSelect = _ref.onSelect;
  return React.createElement(S.Container, {
    isSelected: isSelected,
    onClick: onSelect
  }, children);
};

export { RadioButton };